
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc5a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc5a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h5VcY", function(module, exports) {

$parcel$export(module.exports, "getTenantHostName", () => $c71f47af2d8f4076$export$51cee75883360c2c);
const $c71f47af2d8f4076$export$51cee75883360c2c = async ()=>{
    // if (!window.browser) {
    // 	return;
    // }
    // if (window.ENV.NEXT_PUBLIC_NODE_ENV === "development") {
    // 	return;
    // }
    let response;
    let tId = window.location.hostname.split(".")[0].replace("127", "alpha");
    tId = tId.replace("-cdev", "");
    if (tId === "consignment-tracking" || tId === "dynamic-discussion") tId = "alpha";
    // tId = "alpha";
    try {
        // window.ENV.ORGANISATION_NAME = tId;
        response = await $.ajax({
            url: `https://developerplatform.preprod.dlv2.fxtrt.io/app/core-api/tenant?orgShortName=${tId}`,
            method: "GET"
        });
    } catch (err) {
        console.error(err);
    }
    return response?.data;
};

});


var $h5VcY = parcelRequire("h5VcY");
const $28e7d897891683ac$var$setOrgName = async ()=>{
    const tenantConfig = await (0, $h5VcY.getTenantHostName)();
    document.getElementById("org-name-span").innerText = tenantConfig.organizationShortName + " for more details";
};
$28e7d897891683ac$var$setOrgName();


//# sourceMappingURL=not-found.d81692ba.js.map
